<template>
	<div class="flex w-full flex-col items-center justify-center">
		<p class="">ログインする管理画面を選択してください。</p>
		<div class="justify-cente mt-12 flex">
			<div class="selectBox red flex flex-col justify-between">
				<div>
					<div class="mx-auto mt-6">
						<img
							src="/img/kizuna_logo.png"
							alt=""
							class="mx-auto"
							width="186px"
						/>
					</div>

					<div class="mt-9 text-center text-[14px] font-normal">
						KIZUNAに遷移します。
					</div>

					<div class="text-color-red2 mt-8 text-center text-[14px] text-[16px]">
						Comming Soon !
					</div>
				</div>

				<div class="mt-12 flex justify-center">
					<Button
						:button-type="'button'"
						:button-class="'button-red'"
						:button-icon="'fa-right-to-bracket'"
						:button-text="'移動する'"
						@click="pageMove('kizuna')"
					/>
				</div>
			</div>
			<div class="selectBox green ml-12 flex flex-col justify-between">
				<div>
					<div class="mx-auto mt-6">
						<img
							src="/img/spec_kizuna_logo.png"
							alt=""
							class="mx-auto"
							width="230"
						/>
					</div>

					<div class="mt-8 text-center text-[14px] font-normal">
						KIZUNA特定技能に遷移します。
					</div>

					<div class="text-color-red2 mt-8 text-center text-[14px] text-[16px]">
						Comming Soon !
					</div>
				</div>

				<div class="mt-12 flex justify-center">
					<Button
						:button-type="'button'"
						:button-class="'button-green'"
						:button-icon="'fa-right-to-bracket'"
						:button-text="'移動する'"
						@click="pageMove('spac_kizuna')"
					/>
				</div>
			</div>
			<div class="selectBox blue ml-12 flex flex-col justify-between">
				<div>
					<div class="mx-auto">
						<img src="/img/logo.png" alt="" class="mx-auto" width="160" />
					</div>

					<div class="mt-8 text-center text-[14px] font-normal">
						営業応対履歴に遷移します。
					</div>
				</div>

				<div class="mt-12 flex justify-center">
					<Button
						:button-type="'button'"
						:button-class="'button-blue'"
						:button-icon="'fa-right-to-bracket'"
						:button-text="'移動する'"
						@click="pageMove('cmps')"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup>
// その他
import Button from "@/components/atoms/Button.vue";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
//store
import { useAuthStore } from "@/stores/AuthStore";
import { usePartsStore } from "@/stores/PartsStore";
// utils
import bgAnimaion from "@/utils/BgAnimaion.js";
import toaster from "@/utils/Toaster.js";
// api
import FunctionApi from "@/api/FunctionApi.js";

const authStore = useAuthStore();
const partsStore = usePartsStore();
const functionApi = new FunctionApi();
/* ---------------------------------------------------------------------------
	router
---------------------------------------------------------------------------- */
const router = useRouter();
/* ---------------------------------------------------------------------------
utils
---------------------------------------------------------------------------- */
const { alert } = toaster();
const { animation } = bgAnimaion();
/* ---------------------------------------------------------------------------
	data
---------------------------------------------------------------------------- */
const activeCard = ref(false);
const formData = ref({
	email: "",
	password: ""
});
const errors = ref([]);
const errorText = ref("");

/* ---------------------------------------------------------------------------
	通常のログイン
---------------------------------------------------------------------------- */
async function pageMove(flag) {
	alert("login");

	if (flag == "kizuna") {
		router.push("/login");
	} else if (flag == "spec_kizuna") {
		router.push("/login");
	} else if (flag == "cmps") {
		router.push("/sales/companies");
	}
}
onMounted(() => {
	// animation();
});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.cardBox {
	position: relative;
	width: 100%;
	min-width: 480px;
	max-width: 480px;
}
.cardBox_first {
	background: $bg-white1;
	height: 10px;
	border-radius: 5px 5px 0 0;
	margin: 0 10px;
	padding: 0;
}

.card {
	position: relative;
	background: $bg-white2;
	border-radius: 5px;
	padding: 60px 40px 40px;
	box-sizing: border-box;
	@include boxShadow(0.15);
	@include trans(0.3);
}
.cardBox.active .card:first-child {
	background: #f2f2f2;
	margin: 0 15px;
}
.cardBox.active .card:nth-child(2) {
	background: #fafafa;
	margin: 0 10px;
}
.card_border {
	display: flex;
	align-items: center;
}
.card_border:before {
	margin-right: 2rem;
}
.card_border:after {
	margin-left: 2rem;
}
.card_border:before,
.card_border:after {
	content: "";
	height: 1px;
	flex-grow: 1;
	background-color: #ddd;
}
#layer {
	position: fixed;
	width: 100%;
	height: 100%;
	min-height: 100%;
	z-index: -1;
	background: $bg-white2;
	@include backdropFilter(5px);
	@include glassmorphism(0.2);
}
#canvas {
	position: fixed;
	width: 100%;
	height: 100%;
	min-height: 100%;
	z-index: -2;
	// background-image: url("/img/main_bg.png");
	background-repeat: no-repeat;
	background-position: center;
	background-size: 800px;
}
</style>
